module.exports = __webpack_public_path__ + "img/legal-icon.56f43b6a.svg";